package com.bikompanion.domain

/*
 * Generated from the IANA tz database's zone.tab and backward files: each zone's principal city,
 * to the nearest hundredth of a degree, with legacy names such as Asia/Calcutta mapped to the zone
 * they now link to. Regenerate from a newer tzdata release rather than editing by hand.
 */

private class ZoneCity(
    val latitude: Double,
    val longitude: Double,
)

private val TimeZoneCenters: Map<String, ZoneCity> = mapOf(
    "Africa/Abidjan" to ZoneCity(5.32, -4.03),
    "Africa/Accra" to ZoneCity(5.55, -0.22),
    "Africa/Addis_Ababa" to ZoneCity(9.03, 38.70),
    "Africa/Algiers" to ZoneCity(36.78, 3.05),
    "Africa/Asmara" to ZoneCity(15.33, 38.88),
    "Africa/Asmera" to ZoneCity(-1.28, 36.82),
    "Africa/Bamako" to ZoneCity(12.65, -8.00),
    "Africa/Bangui" to ZoneCity(4.37, 18.58),
    "Africa/Banjul" to ZoneCity(13.47, -16.65),
    "Africa/Bissau" to ZoneCity(11.85, -15.58),
    "Africa/Blantyre" to ZoneCity(-15.78, 35.00),
    "Africa/Brazzaville" to ZoneCity(-4.27, 15.28),
    "Africa/Bujumbura" to ZoneCity(-3.38, 29.37),
    "Africa/Cairo" to ZoneCity(30.05, 31.25),
    "Africa/Casablanca" to ZoneCity(33.65, -7.58),
    "Africa/Ceuta" to ZoneCity(35.88, -5.32),
    "Africa/Conakry" to ZoneCity(9.52, -13.72),
    "Africa/Dakar" to ZoneCity(14.67, -17.43),
    "Africa/Dar_es_Salaam" to ZoneCity(-6.80, 39.28),
    "Africa/Djibouti" to ZoneCity(11.60, 43.15),
    "Africa/Douala" to ZoneCity(4.05, 9.70),
    "Africa/El_Aaiun" to ZoneCity(27.15, -13.20),
    "Africa/Freetown" to ZoneCity(8.50, -13.25),
    "Africa/Gaborone" to ZoneCity(-24.65, 25.92),
    "Africa/Harare" to ZoneCity(-17.83, 31.05),
    "Africa/Johannesburg" to ZoneCity(-26.25, 28.00),
    "Africa/Juba" to ZoneCity(4.85, 31.62),
    "Africa/Kampala" to ZoneCity(0.32, 32.42),
    "Africa/Khartoum" to ZoneCity(15.60, 32.53),
    "Africa/Kigali" to ZoneCity(-1.95, 30.07),
    "Africa/Kinshasa" to ZoneCity(-4.30, 15.30),
    "Africa/Lagos" to ZoneCity(6.45, 3.40),
    "Africa/Libreville" to ZoneCity(0.38, 9.45),
    "Africa/Lome" to ZoneCity(6.13, 1.22),
    "Africa/Luanda" to ZoneCity(-8.80, 13.23),
    "Africa/Lubumbashi" to ZoneCity(-11.67, 27.47),
    "Africa/Lusaka" to ZoneCity(-15.42, 28.28),
    "Africa/Malabo" to ZoneCity(3.75, 8.78),
    "Africa/Maputo" to ZoneCity(-25.97, 32.58),
    "Africa/Maseru" to ZoneCity(-29.47, 27.50),
    "Africa/Mbabane" to ZoneCity(-26.30, 31.10),
    "Africa/Mogadishu" to ZoneCity(2.07, 45.37),
    "Africa/Monrovia" to ZoneCity(6.30, -10.78),
    "Africa/Nairobi" to ZoneCity(-1.28, 36.82),
    "Africa/Ndjamena" to ZoneCity(12.12, 15.05),
    "Africa/Niamey" to ZoneCity(13.52, 2.12),
    "Africa/Nouakchott" to ZoneCity(18.10, -15.95),
    "Africa/Ouagadougou" to ZoneCity(12.37, -1.52),
    "Africa/Porto-Novo" to ZoneCity(6.48, 2.62),
    "Africa/Sao_Tome" to ZoneCity(0.33, 6.73),
    "Africa/Timbuktu" to ZoneCity(5.32, -4.03),
    "Africa/Tripoli" to ZoneCity(32.90, 13.18),
    "Africa/Tunis" to ZoneCity(36.80, 10.18),
    "Africa/Windhoek" to ZoneCity(-22.57, 17.10),
    "America/Adak" to ZoneCity(51.88, -176.66),
    "America/Anchorage" to ZoneCity(61.22, -149.90),
    "America/Anguilla" to ZoneCity(18.20, -63.07),
    "America/Antigua" to ZoneCity(17.05, -61.80),
    "America/Araguaina" to ZoneCity(-7.20, -48.20),
    "America/Argentina/Buenos_Aires" to ZoneCity(-34.60, -58.45),
    "America/Argentina/Catamarca" to ZoneCity(-28.47, -65.78),
    "America/Argentina/ComodRivadavia" to ZoneCity(-28.47, -65.78),
    "America/Argentina/Cordoba" to ZoneCity(-31.40, -64.18),
    "America/Argentina/Jujuy" to ZoneCity(-24.18, -65.30),
    "America/Argentina/La_Rioja" to ZoneCity(-29.43, -66.85),
    "America/Argentina/Mendoza" to ZoneCity(-32.88, -68.82),
    "America/Argentina/Rio_Gallegos" to ZoneCity(-51.63, -69.22),
    "America/Argentina/Salta" to ZoneCity(-24.78, -65.42),
    "America/Argentina/San_Juan" to ZoneCity(-31.53, -68.52),
    "America/Argentina/San_Luis" to ZoneCity(-33.32, -66.35),
    "America/Argentina/Tucuman" to ZoneCity(-26.82, -65.22),
    "America/Argentina/Ushuaia" to ZoneCity(-54.80, -68.30),
    "America/Aruba" to ZoneCity(12.50, -69.97),
    "America/Asuncion" to ZoneCity(-25.27, -57.67),
    "America/Atikokan" to ZoneCity(48.76, -91.62),
    "America/Atka" to ZoneCity(51.88, -176.66),
    "America/Bahia" to ZoneCity(-12.98, -38.52),
    "America/Bahia_Banderas" to ZoneCity(20.80, -105.25),
    "America/Barbados" to ZoneCity(13.10, -59.62),
    "America/Belem" to ZoneCity(-1.45, -48.48),
    "America/Belize" to ZoneCity(17.50, -88.20),
    "America/Blanc-Sablon" to ZoneCity(51.42, -57.12),
    "America/Boa_Vista" to ZoneCity(2.82, -60.67),
    "America/Bogota" to ZoneCity(4.60, -74.08),
    "America/Boise" to ZoneCity(43.61, -116.20),
    "America/Buenos_Aires" to ZoneCity(-34.60, -58.45),
    "America/Cambridge_Bay" to ZoneCity(69.11, -105.05),
    "America/Campo_Grande" to ZoneCity(-20.45, -54.62),
    "America/Cancun" to ZoneCity(21.08, -86.77),
    "America/Caracas" to ZoneCity(10.50, -66.93),
    "America/Catamarca" to ZoneCity(-28.47, -65.78),
    "America/Cayenne" to ZoneCity(4.93, -52.33),
    "America/Cayman" to ZoneCity(19.30, -81.38),
    "America/Chicago" to ZoneCity(41.85, -87.65),
    "America/Chihuahua" to ZoneCity(28.63, -106.08),
    "America/Ciudad_Juarez" to ZoneCity(31.73, -106.48),
    "America/Coral_Harbour" to ZoneCity(8.97, -79.53),
    "America/Cordoba" to ZoneCity(-31.40, -64.18),
    "America/Costa_Rica" to ZoneCity(9.93, -84.08),
    "America/Coyhaique" to ZoneCity(-45.57, -72.07),
    "America/Creston" to ZoneCity(49.10, -116.52),
    "America/Cuiaba" to ZoneCity(-15.58, -56.08),
    "America/Curacao" to ZoneCity(12.18, -69.00),
    "America/Danmarkshavn" to ZoneCity(76.77, -18.67),
    "America/Dawson" to ZoneCity(64.07, -139.42),
    "America/Dawson_Creek" to ZoneCity(55.77, -120.23),
    "America/Denver" to ZoneCity(39.74, -104.98),
    "America/Detroit" to ZoneCity(42.33, -83.05),
    "America/Dominica" to ZoneCity(15.30, -61.40),
    "America/Edmonton" to ZoneCity(53.55, -113.47),
    "America/Eirunepe" to ZoneCity(-6.67, -69.87),
    "America/El_Salvador" to ZoneCity(13.70, -89.20),
    "America/Ensenada" to ZoneCity(32.53, -117.02),
    "America/Fort_Nelson" to ZoneCity(58.80, -122.70),
    "America/Fort_Wayne" to ZoneCity(39.77, -86.16),
    "America/Fortaleza" to ZoneCity(-3.72, -38.50),
    "America/Glace_Bay" to ZoneCity(46.20, -59.95),
    "America/Godthab" to ZoneCity(64.18, -51.73),
    "America/Goose_Bay" to ZoneCity(53.33, -60.42),
    "America/Grand_Turk" to ZoneCity(21.47, -71.13),
    "America/Grenada" to ZoneCity(12.05, -61.75),
    "America/Guadeloupe" to ZoneCity(16.23, -61.53),
    "America/Guatemala" to ZoneCity(14.63, -90.52),
    "America/Guayaquil" to ZoneCity(-2.17, -79.83),
    "America/Guyana" to ZoneCity(6.80, -58.17),
    "America/Halifax" to ZoneCity(44.65, -63.60),
    "America/Havana" to ZoneCity(23.13, -82.37),
    "America/Hermosillo" to ZoneCity(29.07, -110.97),
    "America/Indiana/Indianapolis" to ZoneCity(39.77, -86.16),
    "America/Indiana/Knox" to ZoneCity(41.30, -86.62),
    "America/Indiana/Marengo" to ZoneCity(38.38, -86.34),
    "America/Indiana/Petersburg" to ZoneCity(38.49, -87.28),
    "America/Indiana/Tell_City" to ZoneCity(37.95, -86.76),
    "America/Indiana/Vevay" to ZoneCity(38.75, -85.07),
    "America/Indiana/Vincennes" to ZoneCity(38.68, -87.53),
    "America/Indiana/Winamac" to ZoneCity(41.05, -86.60),
    "America/Indianapolis" to ZoneCity(39.77, -86.16),
    "America/Inuvik" to ZoneCity(68.35, -133.72),
    "America/Iqaluit" to ZoneCity(63.73, -68.47),
    "America/Jamaica" to ZoneCity(17.97, -76.79),
    "America/Jujuy" to ZoneCity(-24.18, -65.30),
    "America/Juneau" to ZoneCity(58.30, -134.42),
    "America/Kentucky/Louisville" to ZoneCity(38.25, -85.76),
    "America/Kentucky/Monticello" to ZoneCity(36.83, -84.85),
    "America/Knox_IN" to ZoneCity(41.30, -86.62),
    "America/Kralendijk" to ZoneCity(12.15, -68.28),
    "America/La_Paz" to ZoneCity(-16.50, -68.15),
    "America/Lima" to ZoneCity(-12.05, -77.05),
    "America/Los_Angeles" to ZoneCity(34.05, -118.24),
    "America/Louisville" to ZoneCity(38.25, -85.76),
    "America/Lower_Princes" to ZoneCity(18.05, -63.05),
    "America/Maceio" to ZoneCity(-9.67, -35.72),
    "America/Managua" to ZoneCity(12.15, -86.28),
    "America/Manaus" to ZoneCity(-3.13, -60.02),
    "America/Marigot" to ZoneCity(18.07, -63.08),
    "America/Martinique" to ZoneCity(14.60, -61.08),
    "America/Matamoros" to ZoneCity(25.83, -97.50),
    "America/Mazatlan" to ZoneCity(23.22, -106.42),
    "America/Mendoza" to ZoneCity(-32.88, -68.82),
    "America/Menominee" to ZoneCity(45.11, -87.61),
    "America/Merida" to ZoneCity(20.97, -89.62),
    "America/Metlakatla" to ZoneCity(55.13, -131.58),
    "America/Mexico_City" to ZoneCity(19.40, -99.15),
    "America/Miquelon" to ZoneCity(47.05, -56.33),
    "America/Moncton" to ZoneCity(46.10, -64.78),
    "America/Monterrey" to ZoneCity(25.67, -100.32),
    "America/Montevideo" to ZoneCity(-34.91, -56.21),
    "America/Montreal" to ZoneCity(43.65, -79.38),
    "America/Montserrat" to ZoneCity(16.72, -62.22),
    "America/Nassau" to ZoneCity(25.08, -77.35),
    "America/New_York" to ZoneCity(40.71, -74.01),
    "America/Nipigon" to ZoneCity(43.65, -79.38),
    "America/Nome" to ZoneCity(64.50, -165.41),
    "America/Noronha" to ZoneCity(-3.85, -32.42),
    "America/North_Dakota/Beulah" to ZoneCity(47.26, -101.78),
    "America/North_Dakota/Center" to ZoneCity(47.12, -101.30),
    "America/North_Dakota/New_Salem" to ZoneCity(46.84, -101.41),
    "America/Nuuk" to ZoneCity(64.18, -51.73),
    "America/Ojinaga" to ZoneCity(29.57, -104.42),
    "America/Panama" to ZoneCity(8.97, -79.53),
    "America/Pangnirtung" to ZoneCity(63.73, -68.47),
    "America/Paramaribo" to ZoneCity(5.83, -55.17),
    "America/Phoenix" to ZoneCity(33.45, -112.07),
    "America/Port-au-Prince" to ZoneCity(18.53, -72.33),
    "America/Port_of_Spain" to ZoneCity(10.65, -61.52),
    "America/Porto_Acre" to ZoneCity(-9.97, -67.80),
    "America/Porto_Velho" to ZoneCity(-8.77, -63.90),
    "America/Puerto_Rico" to ZoneCity(18.47, -66.11),
    "America/Punta_Arenas" to ZoneCity(-53.15, -70.92),
    "America/Rainy_River" to ZoneCity(49.88, -97.15),
    "America/Rankin_Inlet" to ZoneCity(62.82, -92.08),
    "America/Recife" to ZoneCity(-8.05, -34.90),
    "America/Regina" to ZoneCity(50.40, -104.65),
    "America/Resolute" to ZoneCity(74.70, -94.83),
    "America/Rio_Branco" to ZoneCity(-9.97, -67.80),
    "America/Rosario" to ZoneCity(-31.40, -64.18),
    "America/Santa_Isabel" to ZoneCity(32.53, -117.02),
    "America/Santarem" to ZoneCity(-2.43, -54.87),
    "America/Santiago" to ZoneCity(-33.45, -70.67),
    "America/Santo_Domingo" to ZoneCity(18.47, -69.90),
    "America/Sao_Paulo" to ZoneCity(-23.53, -46.62),
    "America/Scoresbysund" to ZoneCity(70.48, -21.97),
    "America/Shiprock" to ZoneCity(39.74, -104.98),
    "America/Sitka" to ZoneCity(57.18, -135.30),
    "America/St_Barthelemy" to ZoneCity(17.88, -62.85),
    "America/St_Johns" to ZoneCity(47.57, -52.72),
    "America/St_Kitts" to ZoneCity(17.30, -62.72),
    "America/St_Lucia" to ZoneCity(14.02, -61.00),
    "America/St_Thomas" to ZoneCity(18.35, -64.93),
    "America/St_Vincent" to ZoneCity(13.15, -61.23),
    "America/Swift_Current" to ZoneCity(50.28, -107.83),
    "America/Tegucigalpa" to ZoneCity(14.10, -87.22),
    "America/Thule" to ZoneCity(76.57, -68.78),
    "America/Thunder_Bay" to ZoneCity(43.65, -79.38),
    "America/Tijuana" to ZoneCity(32.53, -117.02),
    "America/Toronto" to ZoneCity(43.65, -79.38),
    "America/Tortola" to ZoneCity(18.45, -64.62),
    "America/Vancouver" to ZoneCity(49.27, -123.12),
    "America/Virgin" to ZoneCity(18.47, -66.11),
    "America/Whitehorse" to ZoneCity(60.72, -135.05),
    "America/Winnipeg" to ZoneCity(49.88, -97.15),
    "America/Yakutat" to ZoneCity(59.55, -139.73),
    "America/Yellowknife" to ZoneCity(53.55, -113.47),
    "Antarctica/Casey" to ZoneCity(-66.28, 110.52),
    "Antarctica/Davis" to ZoneCity(-68.58, 77.97),
    "Antarctica/DumontDUrville" to ZoneCity(-66.67, 140.02),
    "Antarctica/Macquarie" to ZoneCity(-54.50, 158.95),
    "Antarctica/Mawson" to ZoneCity(-67.60, 62.88),
    "Antarctica/McMurdo" to ZoneCity(-77.83, 166.60),
    "Antarctica/Palmer" to ZoneCity(-64.80, -64.10),
    "Antarctica/Rothera" to ZoneCity(-67.57, -68.13),
    "Antarctica/South_Pole" to ZoneCity(-36.87, 174.77),
    "Antarctica/Syowa" to ZoneCity(-69.01, 39.59),
    "Antarctica/Troll" to ZoneCity(-72.01, 2.53),
    "Antarctica/Vostok" to ZoneCity(-78.40, 106.90),
    "Arctic/Longyearbyen" to ZoneCity(78.00, 16.00),
    "Asia/Aden" to ZoneCity(12.75, 45.20),
    "Asia/Almaty" to ZoneCity(43.25, 76.95),
    "Asia/Amman" to ZoneCity(31.95, 35.93),
    "Asia/Anadyr" to ZoneCity(64.75, 177.48),
    "Asia/Aqtau" to ZoneCity(44.52, 50.27),
    "Asia/Aqtobe" to ZoneCity(50.28, 57.17),
    "Asia/Ashgabat" to ZoneCity(37.95, 58.38),
    "Asia/Ashkhabad" to ZoneCity(37.95, 58.38),
    "Asia/Atyrau" to ZoneCity(47.12, 51.93),
    "Asia/Baghdad" to ZoneCity(33.35, 44.42),
    "Asia/Bahrain" to ZoneCity(26.38, 50.58),
    "Asia/Baku" to ZoneCity(40.38, 49.85),
    "Asia/Bangkok" to ZoneCity(13.75, 100.52),
    "Asia/Barnaul" to ZoneCity(53.37, 83.75),
    "Asia/Beirut" to ZoneCity(33.88, 35.50),
    "Asia/Bishkek" to ZoneCity(42.90, 74.60),
    "Asia/Brunei" to ZoneCity(4.93, 114.92),
    "Asia/Calcutta" to ZoneCity(22.53, 88.37),
    "Asia/Chita" to ZoneCity(52.05, 113.47),
    "Asia/Choibalsan" to ZoneCity(47.92, 106.88),
    "Asia/Chongqing" to ZoneCity(31.23, 121.47),
    "Asia/Chungking" to ZoneCity(31.23, 121.47),
    "Asia/Colombo" to ZoneCity(6.93, 79.85),
    "Asia/Dacca" to ZoneCity(23.72, 90.42),
    "Asia/Damascus" to ZoneCity(33.50, 36.30),
    "Asia/Dhaka" to ZoneCity(23.72, 90.42),
    "Asia/Dili" to ZoneCity(-8.55, 125.58),
    "Asia/Dubai" to ZoneCity(25.30, 55.30),
    "Asia/Dushanbe" to ZoneCity(38.58, 68.80),
    "Asia/Famagusta" to ZoneCity(35.12, 33.95),
    "Asia/Gaza" to ZoneCity(31.50, 34.47),
    "Asia/Harbin" to ZoneCity(31.23, 121.47),
    "Asia/Hebron" to ZoneCity(31.53, 35.09),
    "Asia/Ho_Chi_Minh" to ZoneCity(10.75, 106.67),
    "Asia/Hong_Kong" to ZoneCity(22.28, 114.15),
    "Asia/Hovd" to ZoneCity(48.02, 91.65),
    "Asia/Irkutsk" to ZoneCity(52.27, 104.33),
    "Asia/Istanbul" to ZoneCity(41.02, 28.97),
    "Asia/Jakarta" to ZoneCity(-6.17, 106.80),
    "Asia/Jayapura" to ZoneCity(-2.53, 140.70),
    "Asia/Jerusalem" to ZoneCity(31.78, 35.22),
    "Asia/Kabul" to ZoneCity(34.52, 69.20),
    "Asia/Kamchatka" to ZoneCity(53.02, 158.65),
    "Asia/Karachi" to ZoneCity(24.87, 67.05),
    "Asia/Kashgar" to ZoneCity(43.80, 87.58),
    "Asia/Kathmandu" to ZoneCity(27.72, 85.32),
    "Asia/Katmandu" to ZoneCity(27.72, 85.32),
    "Asia/Khandyga" to ZoneCity(62.66, 135.55),
    "Asia/Kolkata" to ZoneCity(22.53, 88.37),
    "Asia/Krasnoyarsk" to ZoneCity(56.02, 92.83),
    "Asia/Kuala_Lumpur" to ZoneCity(3.17, 101.70),
    "Asia/Kuching" to ZoneCity(1.55, 110.33),
    "Asia/Kuwait" to ZoneCity(29.33, 47.98),
    "Asia/Macao" to ZoneCity(22.20, 113.54),
    "Asia/Macau" to ZoneCity(22.20, 113.54),
    "Asia/Magadan" to ZoneCity(59.57, 150.80),
    "Asia/Makassar" to ZoneCity(-5.12, 119.40),
    "Asia/Manila" to ZoneCity(14.59, 120.97),
    "Asia/Muscat" to ZoneCity(23.60, 58.58),
    "Asia/Nicosia" to ZoneCity(35.17, 33.37),
    "Asia/Novokuznetsk" to ZoneCity(53.75, 87.12),
    "Asia/Novosibirsk" to ZoneCity(55.03, 82.92),
    "Asia/Omsk" to ZoneCity(55.00, 73.40),
    "Asia/Oral" to ZoneCity(51.22, 51.35),
    "Asia/Phnom_Penh" to ZoneCity(11.55, 104.92),
    "Asia/Pontianak" to ZoneCity(-0.03, 109.33),
    "Asia/Pyongyang" to ZoneCity(39.02, 125.75),
    "Asia/Qatar" to ZoneCity(25.28, 51.53),
    "Asia/Qostanay" to ZoneCity(53.20, 63.62),
    "Asia/Qyzylorda" to ZoneCity(44.80, 65.47),
    "Asia/Rangoon" to ZoneCity(16.78, 96.17),
    "Asia/Riyadh" to ZoneCity(24.63, 46.72),
    "Asia/Saigon" to ZoneCity(10.75, 106.67),
    "Asia/Sakhalin" to ZoneCity(46.97, 142.70),
    "Asia/Samarkand" to ZoneCity(39.67, 66.80),
    "Asia/Seoul" to ZoneCity(37.55, 126.97),
    "Asia/Shanghai" to ZoneCity(31.23, 121.47),
    "Asia/Singapore" to ZoneCity(1.28, 103.85),
    "Asia/Srednekolymsk" to ZoneCity(67.47, 153.72),
    "Asia/Taipei" to ZoneCity(25.05, 121.50),
    "Asia/Tashkent" to ZoneCity(41.33, 69.30),
    "Asia/Tbilisi" to ZoneCity(41.72, 44.82),
    "Asia/Tehran" to ZoneCity(35.67, 51.43),
    "Asia/Tel_Aviv" to ZoneCity(31.78, 35.22),
    "Asia/Thimbu" to ZoneCity(27.47, 89.65),
    "Asia/Thimphu" to ZoneCity(27.47, 89.65),
    "Asia/Tokyo" to ZoneCity(35.65, 139.74),
    "Asia/Tomsk" to ZoneCity(56.50, 84.97),
    "Asia/Ujung_Pandang" to ZoneCity(-5.12, 119.40),
    "Asia/Ulaanbaatar" to ZoneCity(47.92, 106.88),
    "Asia/Ulan_Bator" to ZoneCity(47.92, 106.88),
    "Asia/Urumqi" to ZoneCity(43.80, 87.58),
    "Asia/Ust-Nera" to ZoneCity(64.56, 143.23),
    "Asia/Vientiane" to ZoneCity(17.97, 102.60),
    "Asia/Vladivostok" to ZoneCity(43.17, 131.93),
    "Asia/Yakutsk" to ZoneCity(62.00, 129.67),
    "Asia/Yangon" to ZoneCity(16.78, 96.17),
    "Asia/Yekaterinburg" to ZoneCity(56.85, 60.60),
    "Asia/Yerevan" to ZoneCity(40.18, 44.50),
    "Atlantic/Azores" to ZoneCity(37.73, -25.67),
    "Atlantic/Bermuda" to ZoneCity(32.28, -64.77),
    "Atlantic/Canary" to ZoneCity(28.10, -15.40),
    "Atlantic/Cape_Verde" to ZoneCity(14.92, -23.52),
    "Atlantic/Faeroe" to ZoneCity(62.02, -6.77),
    "Atlantic/Faroe" to ZoneCity(62.02, -6.77),
    "Atlantic/Jan_Mayen" to ZoneCity(52.50, 13.37),
    "Atlantic/Madeira" to ZoneCity(32.63, -16.90),
    "Atlantic/Reykjavik" to ZoneCity(64.15, -21.85),
    "Atlantic/South_Georgia" to ZoneCity(-54.27, -36.53),
    "Atlantic/St_Helena" to ZoneCity(-15.92, -5.70),
    "Atlantic/Stanley" to ZoneCity(-51.70, -57.85),
    "Australia/ACT" to ZoneCity(-33.87, 151.22),
    "Australia/Adelaide" to ZoneCity(-34.92, 138.58),
    "Australia/Brisbane" to ZoneCity(-27.47, 153.03),
    "Australia/Broken_Hill" to ZoneCity(-31.95, 141.45),
    "Australia/Canberra" to ZoneCity(-33.87, 151.22),
    "Australia/Currie" to ZoneCity(-42.88, 147.32),
    "Australia/Darwin" to ZoneCity(-12.47, 130.83),
    "Australia/Eucla" to ZoneCity(-31.72, 128.87),
    "Australia/Hobart" to ZoneCity(-42.88, 147.32),
    "Australia/LHI" to ZoneCity(-31.55, 159.08),
    "Australia/Lindeman" to ZoneCity(-20.27, 149.00),
    "Australia/Lord_Howe" to ZoneCity(-31.55, 159.08),
    "Australia/Melbourne" to ZoneCity(-37.82, 144.97),
    "Australia/NSW" to ZoneCity(-33.87, 151.22),
    "Australia/North" to ZoneCity(-12.47, 130.83),
    "Australia/Perth" to ZoneCity(-31.95, 115.85),
    "Australia/Queensland" to ZoneCity(-27.47, 153.03),
    "Australia/South" to ZoneCity(-34.92, 138.58),
    "Australia/Sydney" to ZoneCity(-33.87, 151.22),
    "Australia/Tasmania" to ZoneCity(-42.88, 147.32),
    "Australia/Victoria" to ZoneCity(-37.82, 144.97),
    "Australia/West" to ZoneCity(-31.95, 115.85),
    "Australia/Yancowinna" to ZoneCity(-31.95, 141.45),
    "Brazil/Acre" to ZoneCity(-9.97, -67.80),
    "Brazil/DeNoronha" to ZoneCity(-3.85, -32.42),
    "Brazil/East" to ZoneCity(-23.53, -46.62),
    "Brazil/West" to ZoneCity(-3.13, -60.02),
    "CET" to ZoneCity(50.83, 4.33),
    "Canada/Atlantic" to ZoneCity(44.65, -63.60),
    "Canada/Central" to ZoneCity(49.88, -97.15),
    "Canada/Eastern" to ZoneCity(43.65, -79.38),
    "Canada/Mountain" to ZoneCity(53.55, -113.47),
    "Canada/Newfoundland" to ZoneCity(47.57, -52.72),
    "Canada/Pacific" to ZoneCity(49.27, -123.12),
    "Canada/Saskatchewan" to ZoneCity(50.40, -104.65),
    "Canada/Yukon" to ZoneCity(60.72, -135.05),
    "Chile/Continental" to ZoneCity(-33.45, -70.67),
    "Chile/EasterIsland" to ZoneCity(-27.15, -109.43),
    "Cuba" to ZoneCity(23.13, -82.37),
    "EET" to ZoneCity(37.97, 23.72),
    "EST" to ZoneCity(8.97, -79.53),
    "Egypt" to ZoneCity(30.05, 31.25),
    "Eire" to ZoneCity(53.33, -6.25),
    "Europe/Amsterdam" to ZoneCity(52.37, 4.90),
    "Europe/Andorra" to ZoneCity(42.50, 1.52),
    "Europe/Astrakhan" to ZoneCity(46.35, 48.05),
    "Europe/Athens" to ZoneCity(37.97, 23.72),
    "Europe/Belfast" to ZoneCity(51.51, -0.13),
    "Europe/Belgrade" to ZoneCity(44.83, 20.50),
    "Europe/Berlin" to ZoneCity(52.50, 13.37),
    "Europe/Bratislava" to ZoneCity(48.15, 17.12),
    "Europe/Brussels" to ZoneCity(50.83, 4.33),
    "Europe/Bucharest" to ZoneCity(44.43, 26.10),
    "Europe/Budapest" to ZoneCity(47.50, 19.08),
    "Europe/Busingen" to ZoneCity(47.70, 8.68),
    "Europe/Chisinau" to ZoneCity(47.00, 28.83),
    "Europe/Copenhagen" to ZoneCity(55.67, 12.58),
    "Europe/Dublin" to ZoneCity(53.33, -6.25),
    "Europe/Gibraltar" to ZoneCity(36.13, -5.35),
    "Europe/Guernsey" to ZoneCity(49.45, -2.54),
    "Europe/Helsinki" to ZoneCity(60.17, 24.97),
    "Europe/Isle_of_Man" to ZoneCity(54.15, -4.47),
    "Europe/Istanbul" to ZoneCity(41.02, 28.97),
    "Europe/Jersey" to ZoneCity(49.18, -2.11),
    "Europe/Kaliningrad" to ZoneCity(54.72, 20.50),
    "Europe/Kiev" to ZoneCity(50.43, 30.52),
    "Europe/Kirov" to ZoneCity(58.60, 49.65),
    "Europe/Kyiv" to ZoneCity(50.43, 30.52),
    "Europe/Lisbon" to ZoneCity(38.72, -9.13),
    "Europe/Ljubljana" to ZoneCity(46.05, 14.52),
    "Europe/London" to ZoneCity(51.51, -0.13),
    "Europe/Luxembourg" to ZoneCity(49.60, 6.15),
    "Europe/Madrid" to ZoneCity(40.40, -3.68),
    "Europe/Malta" to ZoneCity(35.90, 14.52),
    "Europe/Mariehamn" to ZoneCity(60.10, 19.95),
    "Europe/Minsk" to ZoneCity(53.90, 27.57),
    "Europe/Monaco" to ZoneCity(43.70, 7.38),
    "Europe/Moscow" to ZoneCity(55.76, 37.62),
    "Europe/Nicosia" to ZoneCity(35.17, 33.37),
    "Europe/Oslo" to ZoneCity(59.92, 10.75),
    "Europe/Paris" to ZoneCity(48.87, 2.33),
    "Europe/Podgorica" to ZoneCity(42.43, 19.27),
    "Europe/Prague" to ZoneCity(50.08, 14.43),
    "Europe/Riga" to ZoneCity(56.95, 24.10),
    "Europe/Rome" to ZoneCity(41.90, 12.48),
    "Europe/Samara" to ZoneCity(53.20, 50.15),
    "Europe/San_Marino" to ZoneCity(43.92, 12.47),
    "Europe/Sarajevo" to ZoneCity(43.87, 18.42),
    "Europe/Saratov" to ZoneCity(51.57, 46.03),
    "Europe/Simferopol" to ZoneCity(44.95, 34.10),
    "Europe/Skopje" to ZoneCity(41.98, 21.43),
    "Europe/Sofia" to ZoneCity(42.68, 23.32),
    "Europe/Stockholm" to ZoneCity(59.33, 18.05),
    "Europe/Tallinn" to ZoneCity(59.42, 24.75),
    "Europe/Tirane" to ZoneCity(41.33, 19.83),
    "Europe/Tiraspol" to ZoneCity(47.00, 28.83),
    "Europe/Ulyanovsk" to ZoneCity(54.33, 48.40),
    "Europe/Uzhgorod" to ZoneCity(50.43, 30.52),
    "Europe/Vaduz" to ZoneCity(47.15, 9.52),
    "Europe/Vatican" to ZoneCity(41.90, 12.45),
    "Europe/Vienna" to ZoneCity(48.22, 16.33),
    "Europe/Vilnius" to ZoneCity(54.68, 25.32),
    "Europe/Volgograd" to ZoneCity(48.73, 44.42),
    "Europe/Warsaw" to ZoneCity(52.25, 21.00),
    "Europe/Zagreb" to ZoneCity(45.80, 15.97),
    "Europe/Zaporozhye" to ZoneCity(50.43, 30.52),
    "Europe/Zurich" to ZoneCity(47.38, 8.53),
    "GB" to ZoneCity(51.51, -0.13),
    "GB-Eire" to ZoneCity(51.51, -0.13),
    "HST" to ZoneCity(21.31, -157.86),
    "Hongkong" to ZoneCity(22.28, 114.15),
    "Iceland" to ZoneCity(5.32, -4.03),
    "Indian/Antananarivo" to ZoneCity(-18.92, 47.52),
    "Indian/Chagos" to ZoneCity(-7.33, 72.42),
    "Indian/Christmas" to ZoneCity(-10.42, 105.72),
    "Indian/Cocos" to ZoneCity(-12.17, 96.92),
    "Indian/Comoro" to ZoneCity(-11.68, 43.27),
    "Indian/Kerguelen" to ZoneCity(-49.35, 70.22),
    "Indian/Mahe" to ZoneCity(-4.67, 55.47),
    "Indian/Maldives" to ZoneCity(4.17, 73.50),
    "Indian/Mauritius" to ZoneCity(-20.17, 57.50),
    "Indian/Mayotte" to ZoneCity(-12.78, 45.23),
    "Indian/Reunion" to ZoneCity(-20.87, 55.47),
    "Iran" to ZoneCity(35.67, 51.43),
    "Israel" to ZoneCity(31.78, 35.22),
    "Jamaica" to ZoneCity(17.97, -76.79),
    "Japan" to ZoneCity(35.65, 139.74),
    "Kwajalein" to ZoneCity(9.08, 167.33),
    "Libya" to ZoneCity(32.90, 13.18),
    "MET" to ZoneCity(50.83, 4.33),
    "MST" to ZoneCity(33.45, -112.07),
    "Mexico/BajaNorte" to ZoneCity(32.53, -117.02),
    "Mexico/BajaSur" to ZoneCity(23.22, -106.42),
    "Mexico/General" to ZoneCity(19.40, -99.15),
    "NZ" to ZoneCity(-36.87, 174.77),
    "NZ-CHAT" to ZoneCity(-43.95, -176.55),
    "Navajo" to ZoneCity(39.74, -104.98),
    "PRC" to ZoneCity(31.23, 121.47),
    "Pacific/Apia" to ZoneCity(-13.83, -171.73),
    "Pacific/Auckland" to ZoneCity(-36.87, 174.77),
    "Pacific/Bougainville" to ZoneCity(-6.22, 155.57),
    "Pacific/Chatham" to ZoneCity(-43.95, -176.55),
    "Pacific/Chuuk" to ZoneCity(7.42, 151.78),
    "Pacific/Easter" to ZoneCity(-27.15, -109.43),
    "Pacific/Efate" to ZoneCity(-17.67, 168.42),
    "Pacific/Enderbury" to ZoneCity(-2.78, -171.72),
    "Pacific/Fakaofo" to ZoneCity(-9.37, -171.23),
    "Pacific/Fiji" to ZoneCity(-18.13, 178.42),
    "Pacific/Funafuti" to ZoneCity(-8.52, 179.22),
    "Pacific/Galapagos" to ZoneCity(-0.90, -89.60),
    "Pacific/Gambier" to ZoneCity(-23.13, -134.95),
    "Pacific/Guadalcanal" to ZoneCity(-9.53, 160.20),
    "Pacific/Guam" to ZoneCity(13.47, 144.75),
    "Pacific/Honolulu" to ZoneCity(21.31, -157.86),
    "Pacific/Johnston" to ZoneCity(21.31, -157.86),
    "Pacific/Kanton" to ZoneCity(-2.78, -171.72),
    "Pacific/Kiritimati" to ZoneCity(1.87, -157.33),
    "Pacific/Kosrae" to ZoneCity(5.32, 162.98),
    "Pacific/Kwajalein" to ZoneCity(9.08, 167.33),
    "Pacific/Majuro" to ZoneCity(7.15, 171.20),
    "Pacific/Marquesas" to ZoneCity(-9.00, -139.50),
    "Pacific/Midway" to ZoneCity(28.22, -177.37),
    "Pacific/Nauru" to ZoneCity(-0.52, 166.92),
    "Pacific/Niue" to ZoneCity(-19.02, -169.92),
    "Pacific/Norfolk" to ZoneCity(-29.05, 167.97),
    "Pacific/Noumea" to ZoneCity(-22.27, 166.45),
    "Pacific/Pago_Pago" to ZoneCity(-14.27, -170.70),
    "Pacific/Palau" to ZoneCity(7.33, 134.48),
    "Pacific/Pitcairn" to ZoneCity(-25.07, -130.08),
    "Pacific/Pohnpei" to ZoneCity(6.97, 158.22),
    "Pacific/Ponape" to ZoneCity(-9.53, 160.20),
    "Pacific/Port_Moresby" to ZoneCity(-9.50, 147.17),
    "Pacific/Rarotonga" to ZoneCity(-21.23, -159.77),
    "Pacific/Saipan" to ZoneCity(15.20, 145.75),
    "Pacific/Samoa" to ZoneCity(-14.27, -170.70),
    "Pacific/Tahiti" to ZoneCity(-17.53, -149.57),
    "Pacific/Tarawa" to ZoneCity(1.42, 173.00),
    "Pacific/Tongatapu" to ZoneCity(-21.13, -175.20),
    "Pacific/Truk" to ZoneCity(-9.50, 147.17),
    "Pacific/Wake" to ZoneCity(19.28, 166.62),
    "Pacific/Wallis" to ZoneCity(-13.30, -176.17),
    "Pacific/Yap" to ZoneCity(-9.50, 147.17),
    "Poland" to ZoneCity(52.25, 21.00),
    "Portugal" to ZoneCity(38.72, -9.13),
    "ROC" to ZoneCity(25.05, 121.50),
    "ROK" to ZoneCity(37.55, 126.97),
    "Singapore" to ZoneCity(1.28, 103.85),
    "Turkey" to ZoneCity(41.02, 28.97),
    "US/Alaska" to ZoneCity(61.22, -149.90),
    "US/Aleutian" to ZoneCity(51.88, -176.66),
    "US/Arizona" to ZoneCity(33.45, -112.07),
    "US/Central" to ZoneCity(41.85, -87.65),
    "US/East-Indiana" to ZoneCity(39.77, -86.16),
    "US/Eastern" to ZoneCity(40.71, -74.01),
    "US/Hawaii" to ZoneCity(21.31, -157.86),
    "US/Indiana-Starke" to ZoneCity(41.30, -86.62),
    "US/Michigan" to ZoneCity(42.33, -83.05),
    "US/Mountain" to ZoneCity(39.74, -104.98),
    "US/Pacific" to ZoneCity(34.05, -118.24),
    "US/Samoa" to ZoneCity(-14.27, -170.70),
    "W-SU" to ZoneCity(55.76, 37.62),
    "WET" to ZoneCity(38.72, -9.13),
)

/** The principal city of the IANA time zone [timeZoneId], or null for a zone with none (UTC). */
internal fun timeZoneCenter(timeZoneId: String): StartPosition? =
    TimeZoneCenters[timeZoneId]?.let { StartPosition(latitude = it.latitude, longitude = it.longitude) }
